import ApiConstant from "../ApiConstant/ApiConstant";
import axios from "axios";

const handleRequestError = (error) => {
  if (error.message.startsWith("Invalid origin")) {
    console.error(error.message);
    return error.message;
  }else if (!error.response) {
    // If it's a network error (no internet connection)
    console.error("Network Error:", error.message);
    return null;
  } else {
    throw error;
  }
};

export const handleLoginController = async (loginInfo) => {
    try{
      const response = await axios.post(ApiConstant.baseApiUser + "/login", loginInfo);
      return response;
    } catch (error) {
      return handleRequestError(error);
    }
}

export const handleNewOtpController = async (email) => {
    try{
      const response = await axios.post(ApiConstant.baseApiUser + `/forgot-pass/${email}`);
      return response;
    } catch (error) {
      return handleRequestError(error);
    }
}

export const handleOtpVerification = async (email, otp) => {
  try{
    const response = await axios.patch(ApiConstant.baseApiUser + `/verification/${email}`, null, {
      params: {
        otp: otp,
        newUser: false
      }
    });
    return response;
  } catch (error) {
    return handleRequestError(error);
  }
}

export const handlePasswordReset = async (email, form) => {
  try{
    const response = await axios.put(ApiConstant.baseApiUser + `/forgot-pass/change-password/${email}`, form);
    return response;
  } catch (error) {
    return handleRequestError(error);
  }
}



